import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createScenario: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.scenarios.create-scenario',
		defaultMessage: 'Create scenario',
		description: 'Label for create scenario option',
	},
	manageScenarios: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.scenarios.manage-scenarios',
		defaultMessage: 'Manage scenarios',
		description: 'Label for manage scenarios option',
	},
	scenarios: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.scenarios.scenarios',
		defaultMessage: 'Scenarios',
		description: 'Group title for scenario options',
	},
});
